module.exports = __webpack_public_path__ + "img/quiz_timer.7fedda1b.png";